module.exports = __webpack_public_path__ + "img/communication1.557096d7.png";